import React, { useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import { InputWithTimeConvertField } from 'src/presentation/components/agent_desktop_components';

export enum TimeUnits {
  NanoSeconds = 'NanoSeconds',
  Seconds = 'Seconds',
  Minutes = 'Minutes',
  Hours = 'Hours',
  StringFormat = 'StringFormat',
}

type TimeInputFieldType = {
  'data-aid'?: string;
  allowDecimalDigits?: boolean;
  attr: string;
  className?: string;
  defaultValue?: string;
  description?: string;
  displayUnits: TimeUnits;
  label?: string;
  placeholder?: string;
  sourceUnits: TimeUnits;
  suffixText?: string;
};

export default function TimeInputField({
  'data-aid': dataAid,
  allowDecimalDigits = true,
  attr,
  className,
  defaultValue = '',
  description,
  displayUnits = TimeUnits.Minutes,
  label,
  sourceUnits = TimeUnits.Seconds,
  suffixText = 'min',
  ...otherProps
}: TimeInputFieldType) {
  const { errors, workingState, updateState, resetError } = useContext(FormContext);
  const valueFromState = get(workingState, attr);

  const error = find(errors, error => error.attr === attr);

  const isNumeric = value => {
    return /^-?\d+$/.test(value);
  };
  const onChange = val => {
    resetError({ attr, errors });

    if (sourceUnits === TimeUnits.StringFormat) {
      updateState(set({}, attr, val || ''));
      return;
    }
    updateState(set({}, attr, isNumeric(val) ? val : ''));
  };

  return (
    <InputWithTimeConvertField
      allowDecimalDigits={allowDecimalDigits}
      className={error ? `${className} invalid` : className}
      data-aid={dataAid}
      defaultValue={defaultValue}
      description={description}
      displayUnits={displayUnits}
      error={get(error, 'detail')}
      label={label}
      onChange={onChange}
      sourceUnits={sourceUnits}
      suffixText={suffixText}
      value={valueFromState}
      {...otherProps}
    />
  );
}
